module.exports = __webpack_public_path__ + "static/media/checkbox0.2aa9c9bf.svg";